import React from 'react';
import popup from '@assets/img/tutorial/popup.png';
import { StepContainer, BoldParagraph, Paragraph } from '../tutorial.styles';
var SegundoStep = function () { return (React.createElement(StepContainer, null,
    React.createElement(BoldParagraph, null, "N\u00F3s temos interesse no seu bem estar!"),
    React.createElement(Paragraph, null, "Por isso, sempre haver\u00E1 um quadro de satisfa\u00E7\u00E3o como este quando voc\u00EA entrar aqui."),
    React.createElement("img", { alt: "", src: popup, width: "65%" }))); };
export default SegundoStep;
